module.exports = __webpack_public_path__ + "img/backgroundImg.3c260042.jpg";